import { render } from "./AddFortigateProfile.vue?vue&type=template&id=b9b60424"
import script from "./AddFortigateProfile.vue?vue&type=script&lang=js"
export * from "./AddFortigateProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__